import { MprcConfirmDialog, MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { enqueueSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    classroomId: string;
    componentId: string;
    onClose: (success?: boolean) => void;
}

export const DoCancelMeeting: React.FC<IProps> = ({ classroomId, componentId, onClose }) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const [saving, setSaving] = useState<boolean>(false);

    return (
        <>
            <MprcRequestIndicator visible={saving} type={"post"} />
            <MprcConfirmDialog
                open
                message={t("Meeting.CancelMeeting.ConfirmMessage")}
                onClose={(yes) => {
                    if (yes) {
                        setSaving(true);
                        let success = false;
                        api.v1.classroomManagement.cancelMeeting({ classroomId, componentId })
                            .then(({ data }) => {
                                if (data) {
                                    enqueueSnackbar(t("Meeting.CancelMeeting.SuccessMessage"), { variant: "success" });
                                    success = true;
                                } else {
                                    enqueueSnackbar(t("Meeting.CancelMeeting.ErrorMessage"), { variant: "error" });
                                }
                            }).catch(e => MprcRequestSnackbarErrorReport(e))
                            .finally(() => {
                                setSaving(false);
                                onClose(success);
                            });
                    } else {
                        onClose();
                    }
                }}
            />
        </>
    );
};
